// Version : 0.0.3
// Author : Vignesh
import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../const';

/** ************** USER SIGNIN START *************** */

export const userSignIn = (loginData: JSON) => {
	const data = {
		userLoginDataToken: loginData,
	};
	const url = `${API_URL}userLoginVerify`;
	return makeApiCall(url, data);
};

export const userLoginVerificationService = (loginData: JSON) => {
	const data = {
		userLoginVerification: loginData,
	};
	const url = `${API_URL}userLoginCheck`;
	return makeApiCall(url, data);
};

/** ************** USER SIGNIN END *************** */

/** ************** USER AUTH CHECK START *************** */
export const authUserVerification = (authLogVerifiy: JSON) => {
	const data = {
		UserCheckAuth: authLogVerifiy,
	};
	const url = `${API_URL}userAuthVerification`;
	return makeApiCall(url, data);
};
/** ************** USER AUTH CHECK END *************** */

/** ************** FORGOT PASSWORD START *************** */
export const forgotPasswordUpdate = (forgotData: JSON) => {
	const data = {
		forgotPasswordToken: forgotData,
	};
	const url = `${API_URL}verifyForgotPassword`;
	return makeApiCall(url, data);
};
/** ************** FORGOT PASSWORD END *************** */

/** ************** UPDATE USER PASSWORD START *************** */
export const updateUserPasswordCall = (encodeData: JSON) => {
	const data = {
		UpdateUserPasswordToken: encodeData,
	};
	const url = `${API_URL}updateLoginUserPassword`;
	return makeApiCall(url, data);
};
/** ************** UPDATE USER PASSWORD END *************** */

/** ************** UPDATE COMPANY LOGIN DETAILS START *************** */
export const userCompanyLoginDetailsGet = (listData: any) => {
	const data = {
		GetCompanyLoginDetailsToken: listData,
	};
	const url = `${API_URL}fetchLoginCompanyDetails`;
	return makeApiCall(url, data);
};
/** ************** UPDATE COMPANY LOGIN DETAILS END *************** */

/** ************** FETCH USER DETAILS START *************** */
export const fetchUserDetailsCall = (userDetailsData: any) => {
	const data = {
		FetchUserDetailsToken: userDetailsData,
	};
	const url = `${API_URL}fetchUserDetails`;
	return makeApiCall(url, data);
};
/** ************** FETCH USER DETAILS END *************** */
